import type React from 'react';
import UserMenu from './UserMenu';

type Props = {
  CenterComponent?: React.ReactNode;
  RightComponent?: React.ReactNode;
  LeftComponent?: React.ReactNode;
  BottomComponent?: React.ReactNode;
  style?: React.CSSProperties;
  sticky?: boolean;
  hideUserMenu?: boolean;
  initialUser?: User;
  NotificationsComponent?: React.ReactNode;
};

const Header = ({
  CenterComponent,
  style,
  sticky,
  LeftComponent,
  hideUserMenu,
  RightComponent,
  NotificationsComponent,
  BottomComponent,
  initialUser
}: Props) => {
  return (
    <div
      className="top-0 z-20 flex flex-col shrink-0 mb-6 bg-white transition border-b border-solid border-[--border-color]"
      style={{position: sticky ? 'sticky' : 'relative', ...style}}
    >
      <div className="w-full flex justify-center items-center px-4 shrink-0 h-20">
        <div className="flex w-0 grow">{LeftComponent}</div>

        {CenterComponent}

        <div className="flex w-0 grow justify-end">
          {RightComponent}
          {hideUserMenu ? null : (
            <>
              {NotificationsComponent}
              <UserMenu initialUser={initialUser} />
            </>
          )}
        </div>
      </div>

      {BottomComponent ? <div className="w-full h-px bg-[--border-color]" /> : null}

      {BottomComponent}
    </div>
  );
};

export default Header;
